import { render, staticRenderFns } from "./formAddEditNews.vue?vue&type=template&id=183c0753&scoped=true"
import script from "./formAddEditNews.vue?vue&type=script&lang=js"
export * from "./formAddEditNews.vue?vue&type=script&lang=js"
import style0 from "./formAddEditNews.vue?vue&type=style&index=0&id=183c0753&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183c0753",
  null
  
)

export default component.exports